import React from "react"
import styles from "./menu-toggle.module.scss"
import MaterialIcon from "../../components-shared/material-icon/material-icon-view"

export interface MenuToggleProps {
  isMenuVisible: boolean
  onShowMenu: () => void
  onHideMenu: () => void
}

export const MenuToggle: React.FC<MenuToggleProps> = ({isMenuVisible, onShowMenu, onHideMenu}) => {
  function onToggle() {
    if (!isMenuVisible && onShowMenu)
      onShowMenu()
    else if (isMenuVisible && onHideMenu)
      onHideMenu()
  }

  return (
    <button className={isMenuVisible ? styles.MenuVisible : styles.MenuInvisible}
            onClick={onToggle}>
      <MaterialIcon name={isMenuVisible ? "close" : "menu"}
                    size="large"/>
    </button>
  )
}